import { getImageFromSlot } from "../dom/getImageFromSlot.js";
import { createStyledSlotOrClone } from "../elements/createStyledSlotOrClone.js";
import { imageHasAlt } from "../accessibility/imageHasAlt.js";
const getValidatedSlotImage = ({
  element,
  slotName
}) => {
  const imageFromSlot = getImageFromSlot({ element, slotRef: slotName });
  const isProperImage = imageHasAlt(imageFromSlot);
  const slotImage = createStyledSlotOrClone({
    element,
    slotRef: slotName
  });
  if (isProperImage && slotImage) {
    return slotImage.cloneNode(true);
  }
  return null;
};
export {
  getValidatedSlotImage
};
//# sourceMappingURL=getValidatedSlotImage.js.map
